// Copyright (c) 2020, Picsa Advisory Services (Pty) Ltd. All rights reserved

import React, { PureComponent, createRef, Fragment } from 'react'
import PropTypes from 'prop-types'

import {
  TextArea,
  MessageVariableChooser,
  SvgIcon,
  CheckboxButtonGroup
} from '../../'

import {
  CHANNEL_SMS_MESSAGEPLUS,
  CHANNEL_TELEGRAM_BROADCAST
} from '../../../constants'

import { hasResponsibility } from '../../../utils'

const variables = [
  'firstName', 'lastName', 'fullName'
]

const textAreaRef = createRef()


export class BulkSMSMessageComposer extends PureComponent {
  static propTypes = {
    employerIdentityId: PropTypes.string,
    channels: PropTypes.array.isRequired,
    onChannelChange: PropTypes.func.isRequired,
    onMessageChange: PropTypes.func.isRequired
  }

  componentDidMount() {
    if (this.props.employerIdentityId && this.state.telegramAvailableAsChannel === null) {
      hasResponsibility(this.props.employerIdentityId, 'messageplus_telegram_employer')
        .then(telegramAvailableAsChannel => (
          this.setState({ telegramAvailableAsChannel })
        ))
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.message !== this.state.message && this.props.onMessageChange) {
      this.props.onMessageChange(this.state.message)
    }
  }

  state = {
    message: '',
    cursor: 0,
    telegramAvailableAsChannel: null
  }

  injectVariable = (variable) => {
    // could use drag & drop mechanism too
    const currentCaretPosition = this.getCaretPosition()

    this.setState(prevState => {
      let prevMessage = prevState.message

      return { message: prevMessage.slice(0, currentCaretPosition) + `{{${variable}}}` + prevMessage.slice(currentCaretPosition) }
    })
  }

  getCaretPosition = () => {
    const textArea = document.getElementById('textArea')
    const position = textArea.selectionStart
    return position
  }

  replaceLast(find, replace, string) {
    var lastIndex = string.lastIndexOf(find)

    if (lastIndex === -1) {
        return string
    }

    var beginString = string.substring(0, lastIndex)
    var endString = string.substring(lastIndex + find.length)

    return beginString + replace + endString
  }

  handleMessageChange = (e) => {
    let message = e.target.value

    this.setState(prevState => {
      let prevMessage = prevState.message

      if (prevMessage.length - message.length === 1) {
        // character has been deleted

        const currentCaretPosition = this.getCaretPosition()
        let firstPartOfString = message.substring(0, currentCaretPosition)
        const restOfString = message.slice(currentCaretPosition)

        // const lastChar = firstPartOfString[currentCaretPosition-1]
        const secondLastChar = firstPartOfString[currentCaretPosition-2]

        if (secondLastChar === '}') {
          return { message }
        }

        const wordsInMessage = message.split(/\s+/)  // space/newline will be evaluated as word separators
        const lastWord = wordsInMessage[wordsInMessage.length - 1]

        if (lastWord[0] === '{' && lastWord[1] === '{') {
          // delete whole word if variable
          firstPartOfString = this.replaceLast(lastWord, '', firstPartOfString)
          return { message: firstPartOfString + restOfString }
        }

        return { message }
      }

      return { message }
    })
  }

  focusOnTextAreaInput = () => textAreaRef.current.focus()

  toggleChannel = (value) => {
    let channelId = null
    if (value === 'SMS') {
      channelId = CHANNEL_SMS_MESSAGEPLUS
    } else if (value === 'Telegram') {
      channelId = CHANNEL_TELEGRAM_BROADCAST
    }
    this.props.onChannelChange(channelId)
  }

  getChannelsForSending = () => {
    let selectedChannels = []

    if (this.props.channels.includes(CHANNEL_SMS_MESSAGEPLUS)) {
      selectedChannels.push('SMS')
    }
    if (this.props.channels.includes(CHANNEL_TELEGRAM_BROADCAST)) {
      selectedChannels.push('Telegram')
    }

    return selectedChannels
  }

  render() {
    const selectedChannels = this.getChannelsForSending()

    return (
      <Fragment>
        {this.state.telegramAvailableAsChannel &&
          <CheckboxButtonGroup
            label='Channel(s) selected for sending'
            options={['SMS', 'Telegram']}
            selectedOption={selectedChannels}
            onChange={e => this.toggleChannel(e.target.value)}
            allowMultiSelect={true}
            className='slds-size_1-of-1 slds-m-bottom_medium'
          />
        }
        <div className='slds-grid'>
          <TextArea
            id='textArea'
            title='Message'
            value={this.state.message}
            onChange={this.handleMessageChange}
            rows={8}
            disabled={this.props.channels.length === 0}
            className='slds-size_2-of-3'
            ref={textAreaRef}
          />
          <MessageVariableChooser
            label='Click to insert placeholder at cursor position'
            variables={variables}
            onClick={variable => {
              this.injectVariable(variable)
              this.focusOnTextAreaInput()
            }}
            className='slds-m-left_small'
          />
        </div>
        <div className='slds-grid slds-m-top_small' style={{ alignItems: 'center' }}>
          <SvgIcon
            variant='utility'
            symbol='info'
            colour='light'
          />
          <div className='slds-text-color_weak slds-m-left_small'>
            <div>
              {`Character count: ${this.state.message.length} `}
              {this.state.message.includes('{{')
                ? <strong>(this count is not accurate with inserted placeholders)</strong>
                : ''
              }
            </div>
            {this.props.channels.includes(CHANNEL_SMS_MESSAGEPLUS) &&
              <div className='slds-text-body_small'>
                NOTE: You will be billed in 160 character units.
              </div>
            }
          </div>
        </div>
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/messageplus/bulk-sms-message-composer/index.js